/**
 * Tema compartido de graficas (estilo shadcn charts).
 * Las graficas usan ChartContainer + ChartTooltipContent de ui/chart;
 * aca viven la paleta y helpers comunes.
 */

// Paleta shadcn (definida en index.css como --chart-1..5, cambia con el tema)
export const CHART = {
  c1: 'hsl(var(--chart-1))',
  c2: 'hsl(var(--chart-2))',
  c3: 'hsl(var(--chart-3))',
  c4: 'hsl(var(--chart-4))',
  c5: 'hsl(var(--chart-5))',
  muted: 'hsl(var(--muted-foreground))'
};

// Colores semanticos por linea de negocio (consistentes en todo el sistema)
export const LINE_COLORS: Record<string, string> = {
  Gomeria: '#185FA5',
  Taller: '#1baf7a',
  Lubricentro: '#BA7517',
  Lavadero: '#378ADD',
  Detailing: '#7F77DD',
  'Sin clasificar': '#98968f'
};

// Props estandar de ejes (look shadcn: sin lineas de eje ni ticks)
export const AXIS = { tickLine: false, axisLine: false, tickMargin: 8, tick: { fontSize: 11 } } as const;

/** @deprecated migrar a ChartTooltip + ChartTooltipContent de ui/chart */
export const tooltipStyle = {
  contentStyle: {
    background: 'hsl(var(--popover))',
    border: '1px solid hsl(var(--border))',
    borderRadius: 8,
    fontSize: 12,
    color: 'hsl(var(--popover-foreground))',
    boxShadow: '0 4px 12px rgba(0,0,0,0.25)'
  },
  labelStyle: {
    color: 'hsl(var(--muted-foreground))',
    fontSize: 11,
    marginBottom: 4
  },
  itemStyle: {
    color: 'hsl(var(--popover-foreground))',
    fontSize: 12
  }
};
